<mat-toolbar color="primary">
  <mat-toolbar-row class="container">
    <span class="dialog-title-with-name">
      <span>{{ (isEdit ? 'modals.register-clinician-payment.edit-title' : 'modals.register-clinician-payment.title') | translate }}</span>
      <span class="dialog-title-name">{{ data.name }}</span>
    </span>
    <span class="modal-toolbar-spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" (click)="!saving ? closeDialogue() : ''"
      [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

@if (saving) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="container my-5">
    <div class="row">
      <div class="col-md-6 mb-3">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>{{ 'modals.register-clinician-payment.amount' | translate }}</mat-label>
          <input matInput type="number" min="0" step="0.01" formControlName="paid_amount">
          <span matTextSuffix>&nbsp;EUR</span>
          @if (!isEdit) {
            <mat-hint>{{ 'modals.register-clinician-payment.amount-hint' | translate }}</mat-hint>
          }
        </mat-form-field>
      </div>
      <div class="col-md-6 mb-3">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>{{ 'modals.register-clinician-payment.date' | translate }}</mat-label>
          <input matInput [matDatepicker]="paymentDatePicker" formControlName="payment_date" (click)="paymentDatePicker.open()" readonly>
          <mat-datepicker-toggle matSuffix [for]="paymentDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #paymentDatePicker></mat-datepicker>
          @if (form.get('payment_date').hasError('required')) {
            <mat-error>{{ 'swal.errors.field-mandatory' | translate }}</mat-error>
          }
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>{{ 'modals.register-clinician-payment.cro' | translate }}</mat-label>
          <input matInput formControlName="cro_reference" maxlength="255">
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="buttons-container container mb-3 d-flex justify-content-center">
    <button mat-stroked-button class="text-dark-purple border-purple mr-2" type="button" [disabled]="saving" (click)="closeDialogue()">{{ 'generic.buttons.cancel-and-back' | translate }}</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="saving">{{ (isEdit ? 'generic.buttons.save' : 'modals.register-clinician-payment.confirm') | translate }}</button>
  </div>
</form>
